import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  PostApiSearchparticipantEmailVerificationMutationRequest,
  PostApiSearchparticipantEmailVerificationMutationResponse,
} from "../../../types/PostApiSearchparticipantEmailVerification";

export function getPostApiSearchparticipantEmailVerificationUrl() {
  return `/api/SearchParticipant/email-verification` as const;
}

/**
 * {@link /api/SearchParticipant/email-verification}
 */
export async function postApiSearchparticipantEmailVerification(
  data?: PostApiSearchparticipantEmailVerificationMutationRequest,
  config: Partial<
    RequestConfig<PostApiSearchparticipantEmailVerificationMutationRequest>
  > & { client?: typeof client } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    PostApiSearchparticipantEmailVerificationMutationResponse,
    ResponseErrorConfig<Error>,
    PostApiSearchparticipantEmailVerificationMutationRequest
  >({
    method: "POST",
    url: getPostApiSearchparticipantEmailVerificationUrl().toString(),
    data,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res;
}
